export default {
  // Login admin
  token: '',
  usuarioAdmin: '',
  datosPerfil: '',
  active_session: false,
}
